
const digest = '66a8d92e987216536151753b9c545e66095e709e53c508de60220e57e1ea8b8c';
const classes = {"wrapper":"_wrapper_k34r5_1","title":"_title_k34r5_7","text":"_text_k34r5_15","formWrapper":"_formWrapper_k34r5_22","button":"_button_k34r5_25","controlsWrapper":"_controlsWrapper_k34r5_44","cancelButton":"_cancelButton_k34r5_49"};
const css = `._wrapper_k34r5_1 {
  font-family: Rubik, "sans-serif";
  background: #ffffff;
  padding: 60px;
  border-radius: 5px;
}
._wrapper_k34r5_1 ._title_k34r5_7 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 30px;
  color: #000000;
  border-bottom: 1px solid #eaedf3;
  padding-bottom: 20px;
}
._wrapper_k34r5_1 ._text_k34r5_15 {
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: -10px;
  border-bottom: 1px solid #eaedf3;
  padding-bottom: 20px;
}
._wrapper_k34r5_1 ._formWrapper_k34r5_22 {
  margin-top: 20px;
}
._wrapper_k34r5_1 ._button_k34r5_25 {
  border-color: #d81616;
  background-color: #d81616;
  font-family: Rubik, sans-serif;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 13px 16px;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  margin-top: 20px;
  border-radius: 25px;
}
._wrapper_k34r5_1 ._button_k34r5_25:hover, ._wrapper_k34r5_1 ._button_k34r5_25:active, ._wrapper_k34r5_1 ._button_k34r5_25:focus {
  border-color: #b00b0b !important;
  background-color: #b00b0b !important;
}
._wrapper_k34r5_1 ._controlsWrapper_k34r5_44 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
._wrapper_k34r5_1 ._controlsWrapper_k34r5_44 ._cancelButton_k34r5_49 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  